export enum VictorQaClasses {
    oneHeader = 'qa-one-header',
    helpCenterBurgerItem = 'qa-blockSuggest__helpCenterLink',
    looksNavItemShort = 'qa-nav-item-look-short',
    looksNavItemLong = 'qa-nav-item-look-long',
    looksNavFlyout = 'qa-nav-flyout-look',
    looksNavFlyoutLink = 'qa-nav-flyout-look--link',
    headerSignUpLink = 'qa-header__sign-up-link',
    headerAccountLink = 'qa-header-account-link',
    headerWishlistLink = 'qa-header-wishlist-link',
    headerWishlistCounter = 'qa-header-wishlist-counter',
    headerCartLink = 'qa-header-cart-link',
    headerCartCounter = 'qa-header-cart-counter',
    headerClubTab = 'qa-header-club-tab',
    headerBurgerMenuAccountItem = 'qa-header-menu-account-link',
    headerBurgerMenuLoginItem = 'qa-header-menu-login-link',
    headerBurgerMenuContainer = 'qa-header-menu-container',
    headerBurgerMenuIcon = 'qa-header-menu-icon',
    headerMenuLink = 'qa-header-menu-link',
    headerSearchIcon = 'qa-header-search-icon',
    headerSearchInput = 'qa-header-search-input',
    headerSearchInputClearIcon = 'qa-header-search-input-clear-icon',
    headerSearchSuggestionFlyout = 'qa-header-search-suggestion-flyout',
    headerSearchSuggestion = 'qa-header-search-suggestion',
    headerPromotionBanner = 'qa-header-promotion-banner',
    headerHelpCenterLink = 'qa-header-helpcenter-link',
    headerHelpCenterFlyout = 'qa-header-helpcenter-flyout',
    headerAccountFlyout = 'qa-header-account-flyout',
    headerNavItem = 'qa-header-nav-item',

    accountMenuMoodboard = 'qa-header-account-menu-moodboard',
    accountMenuReviews = 'qa-header-account-menu-reviews',
    accountMenuOrders = 'qa-header-account-menu-orders',
    accountMenuOverview = 'qa-header-account-menu-overview',
    accountMenuAddress = 'qa-header-account-menu-addresses',
    accountMenuNewletter = 'qa-header-account-menu-newsletters',
    accountMenuWishlist = 'qa-header-account-menu-wishlist',
    accountMenuVoucher = 'qa-header-account-menu-vouchers',

    partialLoginOverlayEmail = 'qa-partial-login-overlay-email',
    partialLoginOverlayPassword = 'qa-partial-login-overlay-password',
    partialLoginOverlaySubmit = 'qa-partial-login-overlay-submit',
}

export enum BellaTestIds {
    menuItem = 'menu-item',
    externalMenuItem = 'external-menu-item',
    menuNavitem = 'menu-cat-nav-item',
    burgerMenuNavitem = 'burger-menu-cat-nav-item',
    categoryFiltergroup = 'facet_category_keys',
    priceFiltergroup = 'facet_price',
    brandFiltergroup = 'facet_brand_keys',
    materialFiltergroup = 'facet_mat_filter',
    colorFiltergroup = 'facet_col',
    categoryFilterItem = 'category-filter-item',
    brandFilterItem = 'brand-filter-item',
    radioBtnLabel = 'radio-btn-label',
    filterCount = 'filter-count',
    productPrice = 'product-price',
    loginRegSubmitBtn = 'login_reg_submit_btn',
    loginRegSwitchBtn = 'login_reg_switch_btn',
    filtersApplyBtn = 'filters_apply_btn',
    filtersResetBtn = 'filters_reset_btn',
    footerLinks = 'footer-links',
    ratingStar = 'rating-star',
    headerCartCounter = 'cart-counter',
    strikeThroughPrice = 'strike-through-price',
    desktopFilterContainer = 'desktop-filter-container',
    moreFiltersButton = 'more-filters-btn',
    pdpWishlistIcon = 'pdp-wishlish-icon',
    pdpWishlistBadge = 'pdp-wishlist-badge',
    notificationBanner = 'notification-banner',
    searchInput = 'search-input',
    searchInputIcon = 'search-input-icon',
    searchInputClearIcon = 'search-input-dismiss-click',
    homepageNewProducts = 'homepage-new-products-slider',
    homepageCategorySlider = 'homepage-category-slider',
    homepageSecondaryBanner = 'homepage-secondary-banner',
    homepageBestSellerProducts = 'homepage-bestseller-products-slider',
    headerBarBanner = 'header-bar-banner-v2',
    headerBarBannerDismissBtn = 'header-bar-banner-v2-dismiss',
    backInStockContainer = 'back-in-stock-container',
    backInStockEmailField = 'back-in-stock-email-field',
    backInStockButton = 'back-in-stock-btn',
    loginRegisterEmailField = 'long-register-email-field',
    loginRegisterPasswordField = 'long-register-password-field',
    alreadySetReminderText = 'already-set-reminder',
    categoriesBubblesSlider = 'categories-bubbles-slider',
    crossCategoryNavigation = 'cross-category-navigation',
    colorVariantItem = 'color-variant-item',
    backToTopButton = 'back-to-top-button',
    dynamicSearchSuggestionsItem = 'dynamic-search-suggestion-item',
    energyEfficiencyLabel = 'energy-efficiency-label',
    wishlistIcon = 'wishlist-icon',
    homepageSingleLookPromotion = 'homepage-single-look-promotion',
    homepageSingleLookPromotionTitle = 'homepage-single-look-promotion-title',
    homepageSingleLookPromotionImage = 'homepage-single-look-promotion-image',
    homepageSingleLookPromotionCta = 'homepage-single-look-promotion-cta',
    homepageSingleLookPromotionCtaDesktop = 'homepage-single-look-promotion-cta-desktop',
    homepageSingleLookPromotionProduct = 'homepage-single-look-promotion-product',

    // PDP
    pdpGalleryRoot = 'pdp-gallery-root',
    pdpGalleryMainImageSliderWrapper = 'pdp-gallery-main-image-slider-wrapper',
    selectedColorVariantItem = 'selected-color-variant-item',
    UnselectedColorVariantItem = 'unselected-color-variant-item',
    pdpImageThumbnail = 'pdp-image-thumbnail',
    pdpSliderLeftArrow = 'pdp-slider-left-arrow',
    pdpSliderRightArrow = 'pdp-slider-right-arrow',
    pdpSliderContainer = 'horizontal-slider',
    pdpSliderImage = 'pdp-slider-image',
    pdpSliderSlide = 'pdp-slider-slide',
    pdpSliderThreeDImageCTA = 'pdp-slider-three-d-image-cta',
    pdpMobileThreeDImageCTA = 'pdp-mobile-three-d-image-cta',
    pdpMobileThreeDImageCTAPlaceholder = 'pdp-mobile-three-s-image-cta-placeholder',
    pdpThreeDModelViewerLoader = 'pdp-three-d-model-viewer-loader',
    pdpThreeDModelViewerZoomInButton = 'pdp-three-d-model-viewer-zoom-in-button',
    pdpThreeDModelViewerZoomOutButton = 'pdp-three-d-model-viewer-zoom-out-button',
    pdpColorVariantImage = 'pdp-color-variant-image',
    productTitlePdp = 'product-title-pdp',
    pdpSizeSelector = 'pdp-size-selector',
    pdpSizeSelectorOverlay = 'pdp-size-selector-overlay',
    pdpSizeSelectorItem = 'pdp-size-selector-item',
    pdpSelectorLabel = 'pdp-selector-label',
    pdpProductPrice = 'pdp-product-price',
    pdpAddToCartBtn = 'pdp-add-to-cart-btn',
    pdpRelatedProducts = 'pdp-related-products',
    pdpDeliveryTimes = 'delivery-times-component',
    pdpValueProps = 'pdp-value-props-component',
    pdpTwoManHandlingSlide = 'two-man-handling-slide',
    pdpTwoManHandlingText = 'two-man-handling-txt-001',
    pdpDeliveryTimeValue = 'delivery-time-value',
    pdpQuantitySelector = 'pdp-quantity-selector',
    nativeVideoPlayIcon = 'native-video-play-icon',
    pdpMainDetailTabContent = 'pdp-main-detail-tab-content',
    pdpMainDetailTabSection = 'pdp-main-detail-tab-section',
    pdpMainDetailTab = 'pdp-main-detail-tab',
    pdpFabricSample = 'pdp-fabric-sample',
    pdpFabricSampleConfirmationButton = 'pdp-fabric-sample-confirmation-button',
    plpSimilarLinksSlider = 'plp-similar-links-slider',

    // PDP reviews
    pdpReviewsInner = 'reviews-inner',
    pdpDetailsTabRatingsBar = 'pdp-details-tab-ratings-bar',
    pdpDetailsTabReviewsShowMoreBtn = 'pdp-details-tab-reviews-show-more',
    pdpDetailsTabReviewsSpinner = 'pdp-detail-tab-reviews-spinner',
    pdpDetailsTabReview = 'pdp-details-tab-review',

    // PDP Looks Infusion
    pdpLooksInfusionVariantNone = 'looks-infusion-variant-none',
    pdpLooksInfusionVariantBottom = 'looks-infusion-variant-bottom',
    pdpLooksInfusionVariantTop = 'looks-infusion-variant-top',
    pdpLooksInfusionObserverPlaceholder = 'looks-infusion-observer-placeholder',
    pdpLooksInfusionMoodImage = 'looks-infusion-mood-image',
    pdpLooksInfusionLastTile = 'looks-infusion-last-tile',
    pdpLooksInfusionCta = 'looks-infusion-cta',
    pdpLooksInfusionSkeleton = 'looks-infusion-skeleton',

    // LDP Connected Looks
    ldpPrevLookLink = 'ldp-prev-look-link',
    ldpNextLookLink = 'ldp-next-look-link',
    ldpPlaceholderLookLink = 'ldp-placeholder-look-link',

    // Navigation flyout header
    NFHBackBtn = 'back_btn',
    NFHRightCloseBtn = 'right_close_btn',
    NFHMenuHeader = 'menu-header',
    NFHMenuTitle = 'menu-title',

    // PLP
    plpNoFilterResultsMainText = 'plp-no-filter-results-main-text',
    plpNoFilterResultsSecondaryText = 'plp-no-filter-results-secondary-text',
    plpNoFilterResultsActionButton = 'plp-no-filter-results-action-button',

    plpProductsGrid = 'plp-products-grid',
    plpAlternativeProductsGrid = 'plp-alternative-products-grid',
    plpAlternativeProductsTitle = 'plp-alternative-products-title',

    zoomOverlayWrapper = 'zoom-overlay-wrapper',
}
